import React from 'react';
import {
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { PopoverComponentRef } from '../Popover';

interface TermsAndConditionsProps extends PopoverComponentRef {
  onOk: (close?: () => void) => void;
}

const TermsAndConditions = function TermsAndConditions(props: TermsAndConditionsProps) {
  const { onOk, close } = props;
  const methods = useForm<{}>();
  const {
    handleSubmit,
  } = methods;

  const submitHandler = () => {
    onOk(close);
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <div className="p-4 pt-6 h-[230px]">
        <div className="h-[150px] overflow-auto">
          This signature page there to intended to be attached to a copy of this document,
          shall be deemed and treated as an original document. The signature of any person
          thereon, for purposes hereof, is to be considered as an original signature, and
          the document transmitted is to be considered to have the same binding effect
          as an original signature on an original document. At the request of any
          party hereto, any facsimile, telecopy or other electronic document is
          to be re-executed in original form by the persons who executed the facsimile,
          telecopy of other electronic document.
        </div>
        <div className="mt-4 flex justify-center">
          <Button
            type="submit"
            variant="contained"
            size="small"
          >
            Accept
          </Button>
        </div>
      </div>
    </form>
  );
};

TermsAndConditions.defaultProps = {

};

TermsAndConditions.propTypes = {

};

export default TermsAndConditions;
